import { render, staticRenderFns } from "./SendInvoice.vue?vue&type=template&id=3c3e468c"
import script from "./SendInvoice.vue?vue&type=script&lang=js"
export * from "./SendInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports